import * as React from "react";

import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";
import { DocumentService, EntityInstancePath } from "@com.mgmtp.a12.kernel/kernel-md-facade";
import { Identifier } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/store";

import { EventButton, RuntimeFachverfahrenManifest } from "../../../app/slices/fachverfahren/types";
import { DisplayType } from "../../../utilities/AnnotationHelper";

export const ActivityContext = React.createContext<
	| {
			hasNavigation: boolean;
			isReadonly: boolean | undefined;
			documentService: DocumentService | undefined;
			fvManifest: RuntimeFachverfahrenManifest | undefined;
			vorgangsnummer: string | undefined;
			archivalInProgress?: string;
			isProcessLocked?: boolean;
			lockProcessErrorMessage?: string;
	  }
	| undefined
>(undefined);

export const EventButtonContext = React.createContext<
	(EventButton & { buttonPath: ModelPath; display: DisplayType; disabledReason?: string }) | undefined
>(undefined);

export const ControlContext = React.createContext<{
	isRequired: boolean;
	onEpayblAmountChange?: (value: string) => boolean;
}>({ isRequired: false });

export const ModulFDataContext = React.createContext<EntityInstancePath>([]);

export const TreeEngineRowActionContext = React.createContext<
	{ eventName: string; nodeIdentifier: Identifier } | undefined
>(undefined);
